import { styled } from 'styled-components';

import { colors, cssBreakpoints, gutterWidth } from '#/theme/theme';

export const CmsEmailCampaignSignup_Box_1 = styled.div`
  width: 100%;
  border-top: 1px solid ${colors.elementGrey};
  flex: 0 0 auto;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    width: 50%;
    border-left: 1px solid ${colors.elementGrey};
    border-top: none;
  }
`;

export const CmsEmailCampaignSignup_Box_2 = styled.div`
  width: 100%;
  flex: 0 0 auto;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    width: 50%;
  }
`;

export const CmsEmailCampaignSignup_Box_3 = styled.div`
  margin-inline: ${-gutterWidth / 2}px;
  padding: 80px 20px;
  width: auto !important;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    margin-inline: ${-gutterWidth}px;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    border-radius: 24px;
  }
`;
